import { render, staticRenderFns } from "./CommentEditForm.vue?vue&type=template&id=6a46b3fe&scoped=true"
import script from "./CommentEditForm.vue?vue&type=script&lang=js"
export * from "./CommentEditForm.vue?vue&type=script&lang=js"
import style0 from "./CommentEditForm.vue?vue&type=style&index=0&id=6a46b3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a46b3fe",
  null
  
)

export default component.exports